// extracted by mini-css-extract-plugin
module.exports = {"item":"CyKm_fq8"};